import React from 'react';
import { Link } from 'react-router-dom';

export const NotFound = () => {
  return (
    <div className="flex flex-col items-center justify-center min-h-screen bg-white">
      <h1 className="text-6xl font-bold text-black mb-4">404</h1>
      <p className="text-xl text-gray-600 mb-8">Oops! This page does not exist.</p>
      <Link 
        to="/"
        className="px-6 py-3 bg-black text-white rounded-lg hover:bg-gray-700 transition-colors"
      >
        Return to home
      </Link>
    </div>
  );
};
